export default {
  生成失败: 'Failed to generate summary',
  AI总结汇总: 'AI Summary'
};
